import {graphql} from 'react-relay';
import {Disposable, Environment} from 'relay-runtime';
import Util from '../forecast-app/shared/util/util';
import {trackEvent} from '../tracking/amplitude/TrackingV2';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';
import type {
	DeleteClientContactMutation,
	DeleteClientContactMutation$data as DeleteClientContactMutationResponse,
	DeleteClientContactMutation$variables,
} from './__generated__/DeleteClientContactMutation.graphql';

type DeleteClientContactInput = DeleteClientContactMutation$variables['input'];

const mutation = graphql`
	mutation DeleteClientContactMutation($input: DeleteClientContactInput!) {
		deleteClientContact(input: $input) {
			deletedClientContactId
			client {
				id
				primaryContactId
			}
		}
	}
`;

export type DeleteClientContactCommitInput = Omit<DeleteClientContactInput, 'csrfToken' | 'socketClientId'>;

function commit(
	environment: Environment,
	input: DeleteClientContactCommitInput,
	onSuccess?: (response: DeleteClientContactMutationResponse) => void,
	onError?: (error: Error) => void
): Disposable {
	return trackAndCommitMutation<DeleteClientContactMutation>(environment, {
		mutation,
		variables: {
			input: {
				...input,
				csrfToken: Util.getCsrfValue(),
				socketClientId: Util.getClientId(),
			},
		},
		onCompleted: (response: DeleteClientContactMutationResponse) => {
			trackEvent('Client Contact', 'Deleted');
			onSuccess?.(response);
		},
		onError,
	});
}

export default {commit};
